import { Injectable } from '@angular/core';
import { UtilityHubIdentity } from '../../auth/models/utility-hub-identity';
import { ProductConfiguration } from '../../configuration/models/product-configuration';
import { QuoteRequestStatus } from '../../shared/models/quote-request-status';
import { Quote, QuoteState } from '../models/quote';
import { DisbaledType, QuotingAvailability } from '../models/quoting-availability';
import { UtilityAccount } from '@app/shared/models/UtilityAccount';
import { QuoteRequestType } from '@app/shared/models/QuoteRequestType';

@Injectable({
  providedIn: 'root',
})
export class QuoteHelperService {


  public CanQuote(quote: Quote, user: UtilityHubIdentity, configuration: ProductConfiguration, upliftDollar: any, newContractStartDate: string[]): boolean {

    let canQuote = false;
    if (quote && quote?.quoteState) {
      canQuote = !(
        quote?.quoteState === QuoteState.APPROVAL_ACCEPTED ||
        quote?.quoteState === QuoteState.APPROVAL_REJECTED ||
        quote?.quoteState === QuoteState.OFFER_ACCEPTED ||
        quote?.quoteState === QuoteState.OFFER_REJECTED ||
        quote?.quoteState === QuoteState.BROKER_REQUESTED ||
        quote?.quoteState === QuoteState.HAS_I_DONT_KNOWS ||
        quote?.quoteState === QuoteState.PENDING_ENROLLMENT ||
        (quote?.quoteRequestState.ownerUserId !== user.id && quote?.quoteState === QuoteState.NOT_QUOTED) ||
        upliftDollar
        )
    }
    if (user.isSupplierManagerOrSalesManager && quote?.quoteRequestState?.status == QuoteRequestStatus.QuoteRequestApproved && quote?.quoteState !== QuoteState.OFFER_ACCEPTED) {
      canQuote = true;
    }
    if ((user.isSupplierManagerOrSalesManager || quote?.quoteRequestState?.ownerUserId === user.id) && quote?.quoteRequestState?.status == QuoteRequestStatus.QuoteRejected) {
      canQuote = true;
    }
    
    if (configuration && newContractStartDate) {
      canQuote = !this.IsQuotationDisabled(configuration, newContractStartDate).isDisabled;
    }

    return canQuote;
  }

  public CanEdit(quote: Quote, user: UtilityHubIdentity) : boolean {
    let canEdit = true;
    if (quote?.quoteState === QuoteState.OFFER_ACCEPTED ||
        quote?.quoteState === QuoteState.REQUEST_APPROVED ||
        quote?.quoteState === QuoteState.OFFER_REJECTED ||
        quote?.quoteState === QuoteState.APPROVAL_REJECTED) {
        canEdit = false;
      }

      if (quote?.quoteState === QuoteState.OFFER_REJECTED && (user.id === quote?.quoteRequestState?.ownerUserId || user.isSupplierManagerOrSalesManager))
      {
        canEdit = true;
      }

    return canEdit;
  }

  public IsQuotationDisabled(supplierProductConfiguration: ProductConfiguration, newContractStartDates: string[]): QuotingAvailability {

    let output = new QuotingAvailability();
    if (supplierProductConfiguration) {
      const anyContractsStartingThisMonth = this.areAnyContractsStartingThisMonth(newContractStartDates);

      if (anyContractsStartingThisMonth) {
        if (supplierProductConfiguration.dayOfMonthQuotingExpires != 0) {
          output.isDisabled = new Date().getDate() >= supplierProductConfiguration.dayOfMonthQuotingExpires;
          if (output.isDisabled)
            output.disabledType = DisbaledType.Month;
        }
      }       
      if (!supplierProductConfiguration.quoteExpirationDisclaimerEnabled && !output.isDisabled && supplierProductConfiguration.quoteValidityNumberOfDays == 0) {
        let now = new Date();
        output.isDisabled = now > new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${supplierProductConfiguration.quoteExpiryIntervalTimeSpan}`);
        if (output.isDisabled)
          output.disabledType = DisbaledType.Day;
      } 
    }
    return output;
  }

  private areAnyContractsStartingThisMonth(newContractStartDates: string[]): boolean {
    if (newContractStartDates) {
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();

      return newContractStartDates.some((newContractStartDate) => {
        if (newContractStartDate) {
          const startDate = new Date(newContractStartDate);
          const startDateMonth = startDate.getMonth();
          const startDateYear = startDate.getFullYear();
  
          return startDateMonth === currentMonth && startDateYear === currentYear;
        }

        return false;
      });
    }

    return false;
  }

  public extractContractStartDates(utilityAccounts: UtilityAccount[]): string[] {
    if(utilityAccounts) {
      return utilityAccounts.map(x => x?.newContractStartDate);
    }
    return [];
  }

  public determineContractStartDates(quote: Quote, quoteConfiguration: any, utilityAccounts: UtilityAccount[]): string[] {
    if (quoteConfiguration || utilityAccounts) {
      if (quote?.quoteRequestState?.quoteRequestType?.replace(/\s+/g, '') === QuoteRequestType.QuickQuote) {
        return [quoteConfiguration.newContractStartMonth];
      } else {
        return this.extractContractStartDates(utilityAccounts);
      }
    }
    return []; 
  }
}